import { useState, useEffect } from 'react';
import AdjustOutlined from '@mui/icons-material/AdjustOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useLocation } from 'react-router-dom';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { CRUD_STATES } from 'constants/app';
import { useNotification } from 'hooks/useNotification';

function DrawerMenu(props) {
  const { videoToCollection, onSubmit, viewFields } = props;
  const [steps, setSteps] = useState([]);
  const { setNotify } = useNotification();
  const location = useLocation();
  const { activeStep, setActiveStep, isLoading } = useAppProviderStore();

  const renderIcons = (activeStep, index) => {
    if (activeStep === index + 1) {
      return (
        <>
          <AdjustOutlined className="icon-stepper step-active" />
          {index + 1 !== props.steps.length && (
            <div className="menu-step-divider"></div>
          )}
        </>
      );
    } else if (activeStep > index) {
      return (
        <>
          <CheckCircleOutlineOutlinedIcon className="icon-stepper step-active" />
          {index + 1 !== props.steps.length && (
            <div className="menu-step-divider-active"></div>
          )}
        </>
      );
    } else {
      return (
        <>
          <AdjustOutlined className="icon-stepper" />
          {index + 1 !== props.steps.length && (
            <div className="menu-step-divider"></div>
          )}
        </>
      );
    }
  };

  useEffect(() => {
    setSteps(props.steps);
  }, [props.steps, props.activeStep]);

  const handleClick = async step => {
    if (videoToCollection?.length > 0) {
      if (location?.state?.action === CRUD_STATES.VIEW || viewFields) {
        if (!isLoading) {
          setActiveStep(step.id);
        }
      } else {
        if (location?.state?.action === CRUD_STATES.CREATE) {
          onSubmit();
        }
        if (!isLoading) {
          setActiveStep(step.id);
        }
      }
    } else {
      setNotify({
        isOpen: true,
        message:
          'A coleção precisa ter ao menos 1 video associado, para avançar selecione os videos que compõe essa coleção.',
        type: 'info',
        title: 'Atenção!',
      });
    }
  };
  return (
    <ul className="menu_step" id="collection-drawer">
      {steps.map((step, index) => (
        <li
          className="menu_step-item"
          // className={`${activeStep === 7
          //   ? "menu_step-item disabled-menu"
          //   : "menu_step-item"
          //   }`}
          key={step.label}
          onClick={() => handleClick(step)}>
          <div className="menu-step-item-divider">
            {renderIcons(activeStep, index)}
          </div>
          <div className="item-content">
            <span
              className={`${
                activeStep === index + 1
                  ? 'menu_step-item-title-active'
                  : 'menu_step-item-title'
              }`}>
              {step.label}
            </span>
            <div
              className={`${
                activeStep === index + 1
                  ? 'step-description-active'
                  : 'step-description'
              }`}>
              {step.description}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default DrawerMenu;
